import { useEffect, useState } from 'react'

/**
 * Kinesis View Log
 * view 로그에 api response data 를 같이 적재하는 경우 사용하는 hook.
 *  - api request 성공해 data가 있는 경우에만 남긴다.
 *  - request 실패 후 retry한 경우에도 남길 수 있다. (fail -> retry -> fail 인 경우는 남기지 않음)
 *  - 한번 로그를 남기면 retry해도 남기지 않는다.
 * @param data  view 로그에 남길 데이터
 * @param sendLog  view 로그 함수
 */
export const useViewLogWithData = <T>({
  data,
  sendLog,
}: {
  data?: T
  sendLog: (data: T) => void
}) => {
  const [isLogSent, setIsLogSent] = useState(false)

  useEffect(() => {
    if (data && !isLogSent) {
      sendLog(data)
      setIsLogSent(true)
    }
  }, [data, isLogSent])
}
